module.exports = __webpack_public_path__ + "media/images/sp/special_plans/separator_suns-5ed098e3d8533f11e30633a07e0eadb2.png";